import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_2 = { class: "icon-rotate" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "io-card-expand__spacer" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "io-card-expand__spacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_IoText = _resolveComponent("IoText")!
  const _component_Expansion = _resolveComponent("Expansion")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["io-card-expand", _ctx.classes])
  }, [
    (_ctx.hasMedia)
      ? (_openBlock(), _createBlock(_component_LazyBackgroundMedia, {
          key: 0,
          "media-sizes": _ctx.mediaSizes,
          class: "io-card-expand__media"
        }, null, 8, ["media-sizes"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.buttonType), {
      onClick: _ctx.toggle,
      class: "io-card-expand__toggle"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        _hoisted_1,
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_FaIcon, { icon: _ctx.icon }, null, 8, ["icon"])
        ])
      ]),
      _: 3
    }, 8, ["onClick"])),
    _createVNode(_component_Expansion, {
      class: "io-card-expand__body",
      expanded: _ctx.component.expanded
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_IoText, { "text-align": "start" }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }),
        _hoisted_4
      ]),
      _: 3
    }, 8, ["expanded"])
  ], 2))
}